import { render } from "./ticketsList.vue?vue&type=template&id=2a20fac4"
import script from "./ticketsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ticketsList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/ticketsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a20fac4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a20fac4', __exports__)) {
    console.log('reload')
    api.reload('2a20fac4', __exports__)
  }
  
  module.hot.accept("./ticketsList.vue?vue&type=template&id=2a20fac4", () => {
    console.log('re-render')
    api.rerender('2a20fac4', render)
  })

}


export default __exports__